export default {
  path: '/software_versions',
  name: 'software_versions',
  component: () => import('../components/softwareversion/Layout'),
  redirect: { name: 'SoftwareVersionList' },
  meta: {
    breadcrumb: 'profile.software.versions',
  },
  children: [
    {
      name: 'SoftwareVersionList',
      path: '',
      component: () => import('../views/softwareversion/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'SoftwareVersionCreate',
      path: 'new',
      component: () => import('../views/softwareversion/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'SoftwareVersionUpdate',
      path: ':id/edit',
      component: () => import('../views/softwareversion/Update'),
      meta: {
        breadcrumb: 'profile.software.version',
      },
    },
    {
      name: 'SoftwareVersionShow',
      path: ':id',
      component: () => import('../views/softwareversion/Show'),
      meta: {
        breadcrumb: 'profile.software.version',
      },
    },
    {
      name: 'SoftwareVersion',
      path: ':parent',
      component: () => import('../components/producttypefile/Layout'),
      meta: {
        breadcrumb: 'qualitycheck.product.producttypefiles',
      },
      children: [
        {
          name: 'ProducttypefileSoftwareVersionCreate',
          path: 'new',
          component: () => import('../views/producttypefile/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
  ]
};
